const locationTerminalMap = (() => {
  const pageLocation = (document.getElementById("pageLocation") != null);
  if (pageLocation) {

    let terminalMap = document.querySelector('.js-terminal-map');
    let introMap = document.querySelector('.js-intro-map');
    let sW = window.innerWidth;

    window.addEventListener("load", () => {
      // console.log("load");
      if (!(sW > 750)) {
        introMap.scrollTo({
          left: 400,
        });
      }

      if (!(sW > 750)) {
        terminalMap.scrollTo({
          left: 400,
        });
      }
    });

  }
})();
export default locationTerminalMap;